export interface ICrisisModalParams {
	isActive: boolean;
	message: string;
	title: string;
}

export const CRISIS_DIALOG_CONTAINER = 'crisis-dialog-container';
export const CRISIS_MODAL_WIDTH = 500;
